module.exports = __webpack_public_path__ + "img/impact-in-action@2x.2cfe5868.webp";